import { useCallback } from 'react';

import { useVideoStreamController_startStream } from '@/services/hooks';

import { mapStreamResponseToDomain } from './mappers';
import type { StartStreamRequest, UseStartStreamResult } from './types';

export function useStartStream(): UseStartStreamResult {
    const mutation = useVideoStreamController_startStream();

    const mutateAsync = useCallback(
        async (variables: StartStreamRequest) => {
            const response = await mutation.mutateAsync(variables);
            return mapStreamResponseToDomain(response.data);
        },
        [mutation.mutateAsync]
    );

    return {
        ...mutation,
        isLoading: mutation.isPending,
        mutateAsync,
        data: mutation.data ? mapStreamResponseToDomain(mutation.data.data) : undefined,
    };
}
